/** Shape returned by GET /getTickerConfigTypes */
export interface ITickerConfigType {
  id: number;
  graphicType: string;
  graphicTitle: string;
  intervalType: TickerIntervalType;
  intervalValue: number;
}

/** Shape returned by GET /match/{matchId}/ticker-config */
export interface IMatchTickerConfig {
  id: number;
  matchId: string;
  graphicType: string;
  automated: boolean;
  intervalType: TickerIntervalType;
  intervalValue: number;
  duration: number;
}

export type TickerIntervalType = 'Ball' | 'Over' | 'Inning';

export const TICKER_INTERVAL_OPTIONS: TickerIntervalType[] = ['Ball', 'Over', 'Inning'];

/** Local state shape for each ticker row while editing */
export interface TickerRowState {
  graphicType: string;
  graphicTitle: string;
  automated: boolean;
  intervalType: TickerIntervalType;
  intervalValue: number;
  /** true = this item has a configurable interval (not event-driven) */
  hasInterval: boolean;
}
